import { PermissionGuard } from '@/features/auth';
import { useRevokeSessionsMutation } from '../hooks/useRevokeSessionsMutation';
import { Alert, Button } from '@/shared/components';

interface Props {
  userId: string;
}

export function UserSessionsPanel({ userId }: Props) {
  const revokeMutation = useRevokeSessionsMutation();

  const handleRevoke = () => {
    if (!window.confirm('Are you sure you want to revoke all sessions? This will invalidate the user\'s current access tokens and refresh token.')) {
      return;
    }
    revokeMutation.mutate(userId);
  };

  return (
    <div className="space-y-2 max-w-2xl">
      <div>
        <h3 className="font-semibold mb-2">Revoke All Sessions</h3>
        <div className="flex items-center gap-4 justify-between">
          <p className="text-sm text-mp-muted">
            Revoking sessions will invalidate the user's current access tokens and refresh token. The user will be signed out of all active sessions immediately.
          </p>
          <PermissionGuard permission={{ resource: 'user', action: 'revoke_sessions' }}>
            <Button
              size="sm"
              variant="danger"
              onClick={handleRevoke}
              disabled={revokeMutation.isPending}
              className="whitespace-nowrap"
            >
              Revoke All Sessions
            </Button>
          </PermissionGuard>
        </div>
      </div>

      {/* Errors surface via the hook-level handleUserMutationError toast — no inline alert. */}

      {revokeMutation.isSuccess && (
        <Alert variant="success">
          <span>All sessions have been revoked successfully.</span>
        </Alert>
      )}
    </div>
  );
}
